import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-white mt-20">
      <div className="container-tharlo py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 bg-gold flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-ink" />
            </div>
            <div className="font-display text-2xl">Tharlo</div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed max-w-sm">
            A premium property discovery platform helping buyers find verified,
            legally transparent properties in Rewa and beyond. Brokers, developers, and owners welcome.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/70">
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> Rewa, Madhya Pradesh, India</div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> hello@tharlo.com</div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> +91 92946 62384</div>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/properties" className="hover:text-gold">Properties</Link></li>
            <li><Link to="/properties?property_type=residential" className="hover:text-gold">Residential</Link></li>
            <li><Link to="/properties?property_type=commercial" className="hover:text-gold">Commercial</Link></li>
            <li><Link to="/properties?property_type=plot" className="hover:text-gold">Plots</Link></li>
            <li><Link to="/properties?property_type=agricultural" className="hover:text-gold">Agricultural</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-4">Sell</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/sell" className="hover:text-gold">List Your Property</Link></li>
            <li><Link to="/sell?ref=broker" className="hover:text-gold">For Brokers & Developers</Link></li>
            <li><Link to="/legal" className="hover:text-gold">Legal Services</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/privacy" className="hover:text-gold">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-gold">Terms & Conditions</Link></li>
            <li><Link to="/refund-policy" className="hover:text-gold">Refund & Cancellation</Link></li>
            <li><Link to="/disclaimer" className="hover:text-gold">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-tharlo py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Tharlo.in — All rights reserved.</div>
          <div className="tracking-[0.2em] uppercase text-gold">Better Properties. Better Decisions.</div>
        </div>
      </div>
    </footer>
  );
}
